export const API_ENDPOINT=process.env.REACT_APP_API_ENDPOINT;
export const STORAGE_ENDPOINT=process.env.REACT_APP_STORAGE_ENDPOINT;
// export const API_ENDPOINT="http://localhost:8090"
// export const API_ENDPOINT="https://veggit-backend.herokuapp.com"
// export const STORAGE_ENDPOINT="https://produceimages.vegg.it"
export const MAPBOX_GEOCODE_API="https://api.mapbox.com/geocoding/v5/mapbox.places/"
